const OPEN = 'OPEN';
const SM_REVIEW = 'SM_REVIEW';
const PI_REVIEW = 'PI_REVIEW';
const COMPLETE = 'COMPLETE';
const CANCELED = 'CANCELED';

export const encounterStatusMap = {
  [OPEN]: 'Open',
  [SM_REVIEW]: 'SM Review',
  [PI_REVIEW]: 'Investigator Review',
  [COMPLETE]: 'Complete',
  [CANCELED]: 'Canceled'
};

export const ACTIVE_SPE_STATUS = 'ACTIVE';
export const CANCELED_SPE_STATUS = 'CANCELED';
export const COMPLETE_SPE_STATUS = 'COMPLETE';

// Encounter Types
export const REGULAR = 'REGULAR';
export const UNEXPECTED = 'UNEXPECTED';
export const NON_PROTOCOL = 'NON_PROTOCOL';
export const SITUATIONAL = 'SITUATIONAL';

export const isSituationalOrUnexpectedEncounter = type => {
  return [SITUATIONAL, UNEXPECTED].includes(type);
};
